import { isMobile } from 'react-device-detect';
import Loadable from '@loadable/component';

export default !isMobile ? Loadable(() => import('./LogoCanvas')) : () => null;
